import { Box, Container, Grid, Link, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { BrandMark } from "@/components/BrandMark";

const Root = styled("footer")(({ theme }) => ({
    padding: theme.spacing(6, 0),
    backgroundColor: "rgb(255, 251, 245)",
    borderTop: `1px solid ${theme.palette.divider}`,
}));

// 빌드 타임에 고정 → 서버/클라이언트 모두 동일한 값으로 hydration mismatch 방지
const CURRENT_YEAR = new Date().getFullYear();

const Footer = (): JSX.Element => {
    return (
        <Root>
            <Container maxWidth="lg">
                <Grid container spacing={4} justifyContent="space-between">
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 900,
                                letterSpacing: -1,
                                mb: 2,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                            }}
                        >
                            <BrandMark size={24} />
                            <Box
                                component="span"
                                sx={{
                                    background: "linear-gradient(135deg, #f5a623, #e8512a)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    backgroundClip: "text",
                                }}
                            >
                                DiningMate
                            </Box>
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Simple, affordable restaurant bookings — built for Australian venues
                            that just want something that works.
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 7 }}>
                        <Grid container spacing={4}>
                            <Grid size={{ xs: 6, sm: 4 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2 }}>
                                    Product
                                </Typography>
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                    <Link href="/#features" variant="body2" color="textSecondary">
                                        Features
                                    </Link>
                                    <Link href="/#pricing" variant="body2" color="textSecondary">
                                        Pricing
                                    </Link>
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 6, sm: 4 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2 }}>
                                    Company
                                </Typography>
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                    <Link href="/#contact" variant="body2" color="textSecondary">
                                        Contact
                                    </Link>
                                    {/* <Link href="#features" variant="body2" color="textSecondary">
                                        Success Stories
                                    </Link> */}
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 6, sm: 4 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 2 }}>
                                    Legal
                                </Typography>
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                    <Link href="/privacy" variant="body2" color="textSecondary">
                                        Privacy Policy
                                    </Link>
                                    <Link href="/terms" variant="body2" color="textSecondary">
                                        Terms of Service
                                    </Link>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Box
                    sx={{
                        mt: 8,
                        pt: 4,
                        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
                    }}
                >
                    <Typography variant="body2" color="textSecondary" align="center">
                        © {CURRENT_YEAR} DiningMate Australia. All rights reserved.
                    </Typography>
                </Box>
            </Container>
        </Root>
    );
};

export default Footer;
